var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 540,
    viewBox: "0 0 1440 540",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10822_7639",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -230,
    width: 1440,
    height: 1080
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -230,
    width: 1440,
    height: 1080,
    fill: "url(#paint0_radial_10822_7639)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10822_7639)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10822_7639)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1080,
    transform: "translate(0 -230)",
    fill: "#0E122F"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972 148C962.1 148 954 156.1 954 166C954 175.9 962.1 184 972 184C981.9 184 990 175.9 990 166C990 156.1 981.99 148 972 148ZM980.281 174.01C979.921 174.549 979.292 174.73 978.75 174.37C974.52 171.76 969.21 171.218 962.909 172.658C962.281 172.841 961.74 172.39 961.56 171.85C961.38 171.219 961.83 170.68 962.37 170.5C969.21 168.969 975.15 169.6 979.83 172.48C980.46 172.75 980.549 173.469 980.281 174.01ZM982.442 169.06C981.99 169.69 981.18 169.96 980.549 169.51C975.69 166.54 968.31 165.64 962.64 167.44C961.922 167.62 961.11 167.26 960.93 166.54C960.75 165.82 961.11 165.008 961.83 164.828C968.4 162.85 976.5 163.842 982.08 167.26C982.621 167.531 982.89 168.43 982.442 169.06ZM982.621 164.02C976.86 160.6 967.23 160.24 961.74 161.951C960.84 162.22 959.94 161.68 959.67 160.87C959.4 159.969 959.94 159.07 960.75 158.799C967.14 156.908 977.67 157.268 984.332 161.23C985.14 161.68 985.41 162.76 984.96 163.57C984.511 164.201 983.43 164.469 982.621 164.02Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332 148C1322.05 148 1314 156.047 1314 166C1314 175.953 1322.05 184 1332 184C1342.39 184 1349.28 176.7 1349.28 166.412C1349.28 165.227 1349.28 164.326 1348.99 163.425H1332V169.605H1342.21C1341.8 172.245 1339.12 177.369 1332 177.369C1325.86 177.369 1320.84 172.27 1320.84 166C1320.84 159.73 1325.86 154.631 1332 154.631C1335.5 154.631 1337.84 156.124 1339.17 157.412L1344.06 152.712C1340.92 149.777 1336.86 148 1332 148Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.7 228.043L1119.66 223.504C1119.66 223.504 1126.45 223.639 1133.21 226.585C1131.48 229.039 1128.04 230.242 1128.04 230.242C1127.81 228.083 1126.2 227.557 1121.08 227.557L1115.7 256L1110.29 227.551C1105.2 227.551 1103.59 228.082 1103.35 230.239C1103.35 230.239 1099.92 229.047 1098.19 226.594C1104.95 223.646 1111.74 223.51 1111.74 223.51L1115.7 228.043L1115.69 228.046H1115.7V228.043ZM1115.7 222.194C1121.16 222.15 1127.42 222.987 1133.82 225.615C1134.68 224.162 1134.9 223.522 1134.9 223.522C1127.9 220.918 1121.34 220.022 1115.7 220C1110.06 220.022 1103.5 220.915 1096.5 223.523C1096.5 223.523 1096.81 224.311 1097.58 225.617C1103.98 222.983 1110.24 222.153 1115.7 222.19V222.194Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.992 301L888.373 317.018C885.253 318.338 882.633 319 880.513 319C878.114 319 876.372 318.16 875.292 316.478C874.613 315.398 874.414 314.029 874.692 312.369C874.971 310.708 875.712 308.94 876.912 307.059C877.912 305.538 879.551 303.539 881.833 301.06C881.059 302.278 880.492 303.616 880.154 305.02C879.554 307.58 880.094 309.459 881.773 310.659C882.573 311.218 883.672 311.499 885.073 311.499C886.191 311.499 887.451 311.319 888.852 310.959L925.992 301Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.93 304.275C1274.75 304.38 1270.76 306.57 1270.8 311.125C1270.85 316.574 1275.87 318.388 1275.92 318.409C1275.88 318.539 1275.12 320.993 1273.28 323.528C1271.69 325.724 1270.04 327.908 1267.44 327.953C1264.89 327.998 1264.06 326.523 1261.15 326.523C1258.22 326.523 1257.31 327.908 1254.89 327.998C1252.38 328.087 1250.47 325.626 1248.87 323.442C1245.59 318.972 1243.09 310.81 1246.45 305.302C1248.12 302.567 1251.11 300.834 1254.34 300.789C1256.81 300.745 1259.14 302.353 1260.64 302.353C1262.13 302.353 1264.8 300.479 1267.94 300.698C1269.17 300.784 1272.66 301.131 1274.93 304.275ZM1266 297.747C1267.33 296.226 1268.23 294.107 1267.98 292C1266.06 292.072 1263.74 293.207 1262.36 294.727C1261.13 296.074 1260.05 298.231 1260.34 300.295C1262.48 300.451 1264.67 299.269 1266 297.747Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.08 391.934C1023.21 391.741 1023.41 391.731 1023.69 391.899C1030.09 395.379 1037.06 397.119 1044.58 397.119C1049.6 397.119 1054.55 396.243 1059.44 394.492C1059.57 394.444 1059.75 394.372 1060 394.276C1060.24 394.179 1060.41 394.109 1060.52 394.059C1060.9 393.915 1061.2 393.988 1061.42 394.276C1061.64 394.562 1061.57 394.827 1061.21 395.068C1060.75 395.38 1060.16 395.74 1059.44 396.147C1057.24 397.371 1054.78 398.32 1052.07 398.991C1049.36 399.664 1046.71 400 1044.12 400C1040.13 400 1036.35 399.346 1032.79 398.038C1029.23 396.73 1026.05 394.89 1023.23 392.512C1023.08 392.393 1023 392.273 1023 392.15C1023 392.079 1023.03 392.007 1023.08 391.934ZM1034.63 381.675C1034.63 380.019 1035.07 378.603 1035.94 377.426C1036.81 376.251 1038 375.363 1039.51 374.763C1040.89 374.21 1042.6 373.814 1044.62 373.575C1045.31 373.503 1046.44 373.407 1048 373.286V372.675C1048 371.139 1047.82 370.108 1047.46 369.579C1046.92 368.859 1046.08 368.5 1044.93 368.5H1044.62C1043.77 368.572 1043.04 368.824 1042.43 369.256C1041.82 369.689 1041.42 370.288 1041.24 371.056C1041.14 371.536 1040.88 371.813 1040.47 371.884L1036.06 371.38C1035.62 371.284 1035.4 371.067 1035.4 370.732C1035.4 370.66 1035.42 370.576 1035.44 370.48C1035.88 368.344 1036.94 366.76 1038.65 365.728C1040.35 364.695 1042.34 364.12 1044.62 364H1045.58C1048.5 364 1050.78 364.708 1052.41 366.125C1052.67 366.364 1052.9 366.623 1053.12 366.898C1053.34 367.174 1053.51 367.419 1053.64 367.636C1053.77 367.852 1053.89 368.163 1053.99 368.572C1054.09 368.98 1054.17 369.262 1054.22 369.418C1054.27 369.573 1054.31 369.91 1054.33 370.426C1054.36 370.942 1054.37 371.248 1054.37 371.344V380.055C1054.37 380.68 1054.47 381.25 1054.66 381.766C1054.85 382.281 1055.04 382.654 1055.22 382.882C1055.4 383.11 1055.69 383.475 1056.1 383.98C1056.25 384.197 1056.33 384.388 1056.33 384.556C1056.33 384.75 1056.23 384.916 1056.02 385.06C1053.9 386.787 1052.75 387.723 1052.57 387.867C1052.26 388.083 1051.89 388.107 1051.45 387.939C1051.1 387.651 1050.78 387.375 1050.51 387.109C1050.25 386.847 1050.05 386.654 1049.94 386.534C1049.82 386.414 1049.64 386.18 1049.38 385.833C1049.13 385.485 1048.95 385.25 1048.84 385.131C1047.41 386.595 1046 387.506 1044.62 387.866C1043.75 388.106 1042.67 388.226 1041.39 388.226C1039.42 388.226 1037.8 387.656 1036.54 386.515C1035.27 385.376 1034.63 383.762 1034.63 381.675ZM1041.24 380.956C1041.24 381.891 1041.49 382.642 1041.99 383.207C1042.49 383.769 1043.16 384.053 1044.01 384.053C1044.08 384.053 1044.19 384.04 1044.33 384.016C1044.47 383.992 1044.57 383.981 1044.62 383.981C1045.69 383.717 1046.53 383.069 1047.12 382.036C1047.4 381.58 1047.61 381.083 1047.75 380.543C1047.89 380.003 1047.97 379.565 1047.98 379.229C1047.99 378.894 1048 378.341 1048 377.573V376.673C1046.51 376.673 1045.39 376.769 1044.62 376.96C1042.37 377.559 1041.24 378.891 1041.24 380.956ZM1057.37 392.546C1057.42 392.45 1057.49 392.353 1057.6 392.258C1058.24 391.852 1058.85 391.574 1059.44 391.431C1060.41 391.191 1061.36 391.058 1062.28 391.036C1062.54 391.013 1062.78 391.023 1063.01 391.071C1064.16 391.167 1064.85 391.348 1065.09 391.611C1065.19 391.755 1065.24 391.971 1065.24 392.258V392.511C1065.24 393.351 1064.99 394.34 1064.51 395.482C1064.02 396.623 1063.35 397.54 1062.47 398.235C1062.35 398.332 1062.23 398.381 1062.13 398.381C1062.08 398.381 1062.02 398.367 1061.97 398.343C1061.82 398.272 1061.78 398.14 1061.86 397.947C1062.81 395.861 1063.28 394.408 1063.28 393.593C1063.28 393.329 1063.23 393.137 1063.13 393.015C1062.87 392.728 1062.15 392.584 1060.98 392.584C1060.54 392.584 1060.03 392.607 1059.44 392.656C1058.8 392.727 1058.21 392.798 1057.67 392.87C1057.52 392.87 1057.42 392.847 1057.36 392.798C1057.31 392.751 1057.3 392.703 1057.33 392.656C1057.33 392.631 1057.34 392.594 1057.37 392.546Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413 367.042C1416.55 367.042 1419.43 382.003 1419.43 400.484H1424.6C1424.6 380.589 1419.38 364.484 1412.99 364.484C1409.33 364.484 1406.11 369.309 1403.98 376.892C1401.85 369.31 1398.62 364.484 1394.99 364.484C1388.6 364.484 1383.4 380.575 1383.4 400.47H1388.57C1388.57 381.991 1391.42 367.042 1394.97 367.042C1398.51 367.042 1401.39 380.863 1401.39 397.912H1406.53C1406.53 380.863 1409.43 367.042 1412.97 367.042H1413Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183.42 449.102V446.957C1183.63 446.942 1183.85 446.933 1184.06 446.93C1189.94 446.744 1193.8 451.991 1193.8 451.991C1193.8 451.991 1189.64 457.768 1185.17 457.768C1184.58 457.768 1183.99 457.675 1183.44 457.49V450.971C1185.73 451.249 1186.19 452.257 1187.56 454.549L1190.62 451.978C1190.62 451.978 1188.38 449.05 1184.62 449.05C1184.22 449.041 1183.82 449.059 1183.42 449.102ZM1183.42 442V445.207L1184.06 445.166C1192.23 444.889 1197.57 451.872 1197.57 451.872C1197.57 451.872 1191.45 459.318 1185.08 459.318C1184.52 459.318 1183.98 459.265 1183.44 459.172V461.16C1183.89 461.212 1184.35 461.253 1184.8 461.253C1190.74 461.253 1195.03 458.218 1199.19 454.641C1199.88 455.197 1202.7 456.535 1203.28 457.119C1199.34 460.431 1190.13 463.094 1184.91 463.094C1184.4 463.094 1183.93 463.068 1183.45 463.015V465.811H1206V442H1183.42ZM1183.42 457.489V459.186C1177.94 458.205 1176.41 452.496 1176.41 452.496C1176.41 452.496 1179.05 449.58 1183.42 449.102V450.958H1183.41C1181.12 450.679 1179.32 452.825 1179.32 452.825C1179.32 452.825 1180.34 456.443 1183.42 457.49M1173.68 452.255C1173.68 452.255 1176.93 447.46 1183.43 446.956V445.207C1176.23 445.79 1170 451.885 1170 451.885C1170 451.885 1173.52 462.088 1183.42 463.015V461.16C1176.16 460.26 1173.68 452.255 1173.68 452.255Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332 508C1322.1 508 1314 516.1 1314 526C1314 535.9 1322.1 544 1332 544C1341.9 544 1350 535.9 1350 526C1350 516.1 1341.99 508 1332 508ZM1340.28 534.01C1339.92 534.549 1339.29 534.73 1338.75 534.37C1334.52 531.76 1329.21 531.218 1322.91 532.658C1322.28 532.841 1321.74 532.39 1321.56 531.85C1321.38 531.219 1321.83 530.68 1322.37 530.5C1329.21 528.969 1335.15 529.6 1339.83 532.48C1340.46 532.75 1340.55 533.469 1340.28 534.01ZM1342.44 529.06C1341.99 529.69 1341.18 529.96 1340.55 529.51C1335.69 526.54 1328.31 525.64 1322.64 527.44C1321.92 527.62 1321.11 527.26 1320.93 526.54C1320.75 525.82 1321.11 525.008 1321.83 524.828C1328.4 522.85 1336.5 523.842 1342.08 527.26C1342.62 527.531 1342.89 528.43 1342.44 529.06ZM1342.62 524.02C1336.86 520.6 1327.23 520.24 1321.74 521.951C1320.84 522.22 1319.94 521.68 1319.67 520.87C1319.4 519.969 1319.94 519.07 1320.75 518.799C1327.14 516.908 1337.67 517.268 1344.33 521.23C1345.14 521.68 1345.41 522.76 1344.96 523.57C1344.51 524.201 1343.43 524.469 1342.62 524.02Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10822_7639",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1440 310) scale(851.5 228.892)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10822_7639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1080,
    fill: "white",
    transform: "translate(0 -230)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquities);
export default __webpack_public_path__ + "static/media/equities.59ddf7703c4b7c4d67e634ee0e02ef31.svg";
export { ForwardRef as ReactComponent };